import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

const PreSubmitModal = ({isOpen}) => {

    return (
        <div>
            <Modal isOpen={isOpen}>
                <ModalHeader>
                   EXAM SUBMISSION NOTIFICATION
                </ModalHeader>
                <ModalBody className=' font-weight-bold'>
                    <h5>Dear Candidate</h5>
                    <p>Your exam has been submitted and you will be logged out shortly because the duration for the exam has elapsed.</p>
                    <p>All you attempts have been submitted.</p>
                    <br />
                    <h5>Thank You.</h5>
                </ModalBody>
                {/* <ModalFooter>
                {' '}
                <Button color='success' onClick={toggle}>
                    Okay
                </Button>
                </ModalFooter> */}
            </Modal>
        </div>
    );
}

export default PreSubmitModal;
